import * as events from '../base/constant';
/**
 * `Freeze` module is used to handle Frozen rows and columns.
 *
 * @hidden
 */
export class Freeze {
    constructor(parent, locator) {
        this.parent = parent;
        this.locator = locator;
        this.addEventListener();
    }
    getModuleName() {
        return 'freeze';
    }
    addEventListener() {
        if (this.parent.isDestroyed) {
            return;
        }
        this.parent.on(events.initialLoad, this.instantiateRenderer, this);
        this.parent.on(events.destroy, this.destroy, this);
    }
    instantiateRenderer() {
        this.parent.log('limitation', this.getModuleName());
    }
    removeEventListener() {
        if (this.parent.isDestroyed) {
            return;
        }
        this.parent.off(events.initialLoad, this.instantiateRenderer);
        this.parent.off(events.destroy, this.destroy);
    }
    destroy() {
        this.removeEventListener();
    }
}
